import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { startSessionTimeout, clearSessionTimeout } from '../../services/api';

interface AuthState {
  isAuthenticated: boolean;
  isInitialized: boolean;
  user: {
    id?: number;
    email?: string;
    username?: string;
    firstName?: string;
    lastName?: string;
    companyID?: string;
    companyName?: string;
    roles?: string;
    phoneNumber?: string;
    isDisabled?: boolean;
    isLockedOut?: boolean;
  } | null;
}

const initialState: AuthState = {
  isAuthenticated: false,
  isInitialized: false,
  user: null,
};

export const authSlice = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    setUser: (state, action: PayloadAction<AuthState['user']>) => {
      state.user = action.payload;
      state.isAuthenticated = true;
      if (action.payload) {
        localStorage.setItem('auth', JSON.stringify({
          user: action.payload,
          isAuthenticated: true
        }));
      }
      startSessionTimeout();
    },
    logOut: (state) => {
      state.user = null;
      state.isAuthenticated = false;
      state.isInitialized = false;
      localStorage.removeItem('auth');
      sessionStorage.clear();
      clearSessionTimeout();
    },
    setInitialized: (state, action) => {
      state.isInitialized = action.payload;
    },
    restoreAuth: (state) => {
      try {
        const stored = localStorage.getItem('auth');
        if (stored) {
          const parsed = JSON.parse(stored);
          if (parsed.user && parsed.isAuthenticated) {
            if (!parsed.user.id) {
              localStorage.removeItem('auth');
              state.user = null;
              state.isAuthenticated = false;
              state.isInitialized = true;
              return;
            }
            state.user = parsed.user;
            state.isAuthenticated = true;
            state.isInitialized = true;
            // Restart session timeout
            startSessionTimeout();
          } else {
            state.user = null;
            state.isAuthenticated = false;
            state.isInitialized = true;
          }
        } else {
          state.user = null;
          state.isAuthenticated = false;
          state.isInitialized = true;
        }
      } catch (error) {
        console.error('Failed to restore auth state:', error);
        // Clear potentially corrupted storage
        localStorage.removeItem('auth');
        state.user = null;
        state.isAuthenticated = false;
        state.isInitialized = true;
      }
    }
  },
});

export const { setUser, logOut, setInitialized, restoreAuth } = authSlice.actions;
export default authSlice.reducer;